<h2 mat-dialog-title>{{ 'DIALOGS.EXCEL.title' | translate }}</h2>
<mat-dialog-content>
  <div [formGroup]="uploadForm">
    <mat-form-field>
      <mat-label>{{ 'DIALOGS.EXCEL.row' | translate }}</mat-label>
      <input formControlName="row" matInput>
      @if (uploadForm.controls['row'].hasError('required')) {
        <mat-error>
          {{ 'CONTROLS.required' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'DIALOGS.EXCEL.column' | translate }}</mat-label>
      <input formControlName="column" matInput>
      @if (uploadForm.controls['column'].hasError('required')) {
        <mat-error>
          {{ 'CONTROLS.required' | translate }}
        </mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button color="primary" mat-flat-button>
    <input (change)="uploadFile($event.target.files[0])" class="fileInput" type="file">
    <mat-icon>cloud_upload</mat-icon>
    {{ 'DIALOGS.EXCEL.choose' | translate }}
  </button>
</mat-dialog-actions>
